var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cp-list"},_vm._l((_vm.cpList),function(element){return _c('CodPostalesCard',{key:element._id,attrs:{"cp":element},on:{"cpClicked":_vm.emitClick,"deleteCp":_vm.deleteCp}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }